import { isEqual, pick } from 'lodash';
export function isEqualBy(obj1, obj2, keys) {
    return isEqual(pick(obj1, keys), pick(obj2, keys));
}
